/**
 * Notification Runtime: the template editor's "Send test email".
 *
 * Production email delivery is owned by the Rules Engine (shared render path in
 * notification-email-task-builder). The test send (notification-test-send) renders the template with sample
 * values and calls the `email-sender` bot's `send-test-email` action
 * (ENG-3764 D24), which sends to the requester's own email with a `[TEST]` subject
 * and creates no Task. The former template-trigger runtime that queued
 * send-email-notification Tasks had no callers and was removed.
 */
import type { MedplumClient } from '@medplum/core';

import type { NotificationTemplateConfig } from '../notification-template.types';
import { sendTestEmail as sharedSendTest } from './notification-test-send';

export interface SendTestEmailInput {
  templateConfig: NotificationTemplateConfig;
  recipientEmail: string;
  sampleContext?: Record<string, string>;
  isTest: boolean;
}

/** Render the template with test values and send it through `email-sender` `send-test-email`. */
export async function sendTestEmail(
  medplum: MedplumClient,
  input: SendTestEmailInput,
): Promise<{ ok: boolean; communicationId?: string; error?: string }> {
  const result = await sharedSendTest(medplum, {
    templateConfig: input.templateConfig,
    recipientEmail: input.recipientEmail,
    sampleContext: input.sampleContext,
  });
  return { ok: result.ok, communicationId: result.communicationId, error: result.error };
}
